import { motion } from 'framer-motion';
import { Building2, MapPin, Maximize } from 'lucide-react';

export const PropertyCard = ({ property, featured = false }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <motion.a
      href={`/projects/${property.id}`}
      data-testid={`property-card-${property.id}`}
      whileHover={{ y: -12 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className={`group relative overflow-hidden bg-dark-light rounded-2xl border border-dark-lighter hover:border-rose-gold/50 transition-all duration-500 block shadow-lg hover:shadow-rose-glow ${
        featured ? 'md:col-span-2' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${
        featured ? 'h-[450px]' : 'h-[320px]'
      }`}>
        <img
          src={property.images[0]}
          alt={property.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
        
        {property.status === 'Sold' && (
          <div className="absolute top-6 left-6 bg-red-600/90 backdrop-blur-sm text-white px-5 py-2 rounded-full text-xs font-bold uppercase tracking-wider">
            Sold Out
          </div>
        )}
        {property.featured && (
          <div className="absolute top-6 right-6 bg-rose-gold/90 backdrop-blur-sm text-white px-5 py-2 rounded-full text-xs font-bold uppercase tracking-wider">
            Featured
          </div>
        )}
      </div>

      <div className="p-6">
        <div className="flex items-center gap-2 text-rose-gold text-xs font-semibold mb-4 uppercase tracking-wider">
          <Building2 size={14} />
          <span>{property.builder}</span>
        </div>
        
        <h3 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-3 line-clamp-2 leading-tight">
          {property.title}
        </h3>
        
        <div className="flex items-center gap-2 text-white/60 text-sm mb-6">
          <MapPin size={16} />
          <span className="line-clamp-1">{property.location}</span>
        </div>
        
        <div className="flex items-center justify-between pt-6 border-t border-dark-lighter">
          <div>
            <p className="text-white/40 text-xs mb-2 uppercase tracking-wider">Starting Price</p>
            <p className="text-rose-gold font-heading text-3xl font-bold">
              {formatPrice(property.price)}
            </p>
          </div>
          <div className="text-right">
            <p className="text-white/40 text-xs mb-2 uppercase tracking-wider">Area</p>
            <div className="flex items-center gap-2 text-white font-semibold text-lg">
              <Maximize size={16} />
              <span>{property.area} {property.area_unit}</span>
            </div>
          </div>
        </div>
      </div>
    </motion.a>
  );
};

export default PropertyCard;